import { gql } from '@apollo/client';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { scheduledSessionParticipantEntryProgressFieldsFragment } from './scheduledSessionParticipantEntryProgressFieldsFragment';
import { scheduledSessionParticipantEntryAnswerFieldsFragment } from './scheduledSessionParticipantEntryAnswerFieldsFragment';
import { scheduledSessionParticipantEntryOverrideFieldsFragment } from './scheduledSessionParticipantEntryOverrideFieldsFragment';
import { participantFieldsFragment } from './participantFieldsFragment';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';

export const scheduledSessionParticipantEntryFieldsFragment = gql`
  fragment AdminScheduledSessionParticipantEntryFields on ScheduledSessionParticipantEntry {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    ready
    sessionStart
    currentState {
      status
      stepIndex
      lastUpdated
      evaluation {
        _ref
      }
      question {
        _ref
      }
      rEvaluation {
        ...AdminEvaluationFields
      }
      isCurrentEvaluationEnded
      finishedEvaluationIds
      totalEvaluationsCount
      progressPercentage
      isReassigned
      latestProgress {
        type
        timestamp
        sectionStart
        sectionEnd
      }
      correctedEvaluationIds
      reassignedWithUnsubmittedCorrectionsEvaluationIds
    }
    participant {
      _ref
    }
    sessionOrder {
      _ref
    }
    sessionProgress {
      ...AdminScheduledSessionParticipantEntryProgressFields
    }
    sessionAnswers {
      ...AdminScheduledSessionParticipantEntryAnswerFields
    }
    sessionOverrides {
      ...AdminScheduledSessionParticipantEntryOverrideFields
    }
    rParticipant {
      ...AdminParticipantFields
    }
    rSessionOrder {
      ...AdminEvaluationFields
    }
    timeLeft
    expectedEndTime
  }

  ${sanityDocumentFieldsFragment}
  ${scheduledSessionParticipantEntryProgressFieldsFragment}
  ${scheduledSessionParticipantEntryAnswerFieldsFragment}
  ${scheduledSessionParticipantEntryOverrideFieldsFragment}
  ${participantFieldsFragment}
  ${evaluationFieldsFragment}
`;
